import * as angular from "angular";
import { DialogUtils } from "../../helper/dialog.helper";

let NoPermissionUpgradeComponent = {
    selector: "vcNoPermissionUpgrade",
    templateUrl:
        "/angular/components/campaign-plan/no-permission-upgrade.component.html",
    bindings: {},
    controller: class NoPermissionUpgradeController {
        private dialog: DialogUtils;
        public __env: any;

        constructor(DialogUtils: DialogUtils, __env: any) {
            this.dialog = DialogUtils;
            this.__env = __env;
        }

        cancel(): void {
            this.dialog.hide();
        }
    },
};

angular
    .module("campaignplan")
    .component(
        NoPermissionUpgradeComponent.selector,
        NoPermissionUpgradeComponent
    );
